import React, { useState } from 'react';
import { LogIn, AlertCircle, Loader } from 'lucide-react';
import { API_URL } from '../../config';
import { auth } from '../../apiClient';
import { Card } from '../ui/Card';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';

export const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (!data.success) throw new Error(data.message || 'Login failed');

      auth.setSession(data.token, data.user);
      window.location.href = window.location.origin;
    } catch (err: any) {
      setError(err.message || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card accent className="w-full max-w-md p-8 space-y-6">
      <div>
        <h2 className="display text-2xl text-ink">Welcome back</h2>
        <p className="mt-2 text-sm text-ink-muted">Sign in to your NexSlot account</p>
      </div>

      {error && (
        <div className="p-4 flex items-center gap-3 text-red-700 dark:text-red-300 bg-red-50 dark:bg-red-900/30 rounded-sm border border-red-200 dark:border-red-900">
          <AlertCircle size={18} className="shrink-0" />
          <span className="text-sm font-semibold">{error}</span>
        </div>
      )}

      <form onSubmit={handleLogin} className="space-y-5">
        <Input
          required
          label="Email address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
        />
        <Input
          required
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
        />
        <Button type="submit" variant="primary" full disabled={loading}>
          {loading
            ? <Loader size={18} className="animate-spin" />
            : <><LogIn size={16} /> Sign in</>}
        </Button>
      </form>
    </Card>
  );
};
